import fp from 'lodash/fp'
import { withRouter } from 'react-router-dom'
import { combine, withContext, withCallback } from 'react-hooks-combine'
import { StoreContext } from 'store/context'
import { admin, profile } from 'routes/route.map'

import { ServicesContext } from 'services/context'
import NavTopbar from './component'

export default combine({
  hocs: [withRouter],

  hooks: [
    withContext('appStore', StoreContext),
    withCallback(
      'onSelect',
      () => (selectedItem) => {
        selectedItem.action()
      },
      []
    ),

    // can be undefined
    withContext(
      'memberService',
      ServicesContext,
      (services) => services?.memberService
    ),
  ],

  transformProps: (props) => {
    const { appStore, history } = props
    const isAdmin = fp.get('auth.loggedEntity.isAdmin', appStore)
    const menuItems = []

    if (isAdmin) {
      menuItems.push(
        {
          icon: 'user-shield',
          title: 'Admin',
          action() {
            history.push(admin.beneficiaries())
          },
        },
        {
          icon: 'history',
          title: 'Time Machine',
          action() {
            history.push(admin.timemachine())
          },
        }
      )
    }

    return {
      ...props,
      appStore,
      items: [
        ...menuItems,
        {
          icon: 'user-cog',
          title: 'User details',
          action() {
            history.push(profile.index())
          },
        },
        {
          icon: 'sign-out-alt',
          title: 'Sign out',
          action() {
            appStore.auth.signout()
          },
        },
      ],
    }
  },
})(NavTopbar)
